import { PrimaryCTA } from "./PrimaryCTA";

const ITEMS: ReadonlyArray<readonly [string, string]> = [
  [
    "Unlimited UX/UI design and research",
    "AI-driven design and prototypes with fast turnaround times to test with users or push to main",
  ],
  [
    "AI design-system support",
    "No designer shaped holes. If we stop working together you have the exact skills and markdown files to pickup where we left off",
  ],
  [
    "Landing pages and investor material",
    "Make a splash with an interactive landing page or crush your next pitch with a rad slide deck",
  ],
  [
    "Unlimited revisions",
    "Simply put: we iterate until it’s right",
  ],
];

export function FinalCta() {
  return (
    <section className="final-cta" id="contact" aria-labelledby="final-cta-title">
      <div className="sub-grid final-cta-grid">
        <article className="final-cta-card" data-reveal>
          <div className="final-cta-card-left">
            <h2 id="final-cta-title" className="final-cta-card-title">
              <img
                src="/assets/super-logo@2x.png"
                alt="N801 Studio"
                className="final-cta-card-logo"
              />
            </h2>
            <hr className="final-cta-card-divider" />
            <p className="final-cta-card-tagline">
              Unlimited AI-native product design for ambitious startups
            </p>
          </div>

          <div className="final-cta-card-right">
            <ul className="final-cta-card-list" role="list">
              {ITEMS.map(([heading, desc]) => (
                <li key={heading} className="final-cta-card-item">
                  <span className="final-cta-card-check" aria-hidden="true">
                    <svg viewBox="0 0 20 20" width="20" height="20">
                      <circle cx="10" cy="10" r="10" fill="currentColor" />
                      <path
                        d="M5.8 10.4l2.7 2.7 5.7-5.7"
                        fill="none"
                        stroke="#ECF0F1"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <div className="final-cta-card-item-text">
                    <h3 className="final-cta-card-item-heading">{heading}</h3>
                    <p className="final-cta-card-item-desc">{desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="final-cta-card-price">
              <span className="final-cta-card-price-amount">$5125</span>
              <span className="final-cta-card-price-suffix">/mo &middot; cancel anytime</span>
            </div>
            <PrimaryCTA
              href="https://calendly.com/nathan-alspaugh/new-meeting"
              className="final-cta-card-btn"
            >
              Book a call
            </PrimaryCTA>
          </div>
        </article>
      </div>
    </section>
  );
}
